export const SaveButton = ({ disabled, onClick }: { disabled: boolean, onClick: () => void; }) => (
    <button className="btn btn-sm btn-main" disabled={disabled} onClick={onClick}>Save</button>
)
